export class LazyLoadElement {
  constructor(componentName: string, callback: () => void) {
    const observedElements = new WeakSet<Element>();

    const observeElement = (element: Element) => {
      if (observedElements.has(element)) return;
      observedElements.add(element);

      const componentObserver = new IntersectionObserver(
        async (entries, observer) => {
          if (
            entries[0].isIntersecting &&
            typeof customElements.get(componentName) === 'undefined'
          ) {
            callback();
            observer.disconnect();
          }
        },
        {
          rootMargin:
            Math.max(
              document.documentElement.clientHeight,
              window.innerHeight || 0
            ) + 'px',
        }
      );

      componentObserver.observe(element);
    };

    const setupObserversForAll = () => {
      document.querySelectorAll(componentName).forEach(observeElement);
    };

    // Observe DOM for dynamically added elements
    const mutationObserver = new MutationObserver(() => {
      setupObserversForAll();
    });

    const start = () => {
      setupObserversForAll();
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }
  }
}
